import { Chip, DataTableMeta, DateColumn } from '@otp/ui';
import { TFunction } from 'i18next';
import {
  MostRequestHistory,
  MostRequestHistoryResultDataWithProblem,
  MostRequestHistoryStatus,
} from 'src/graphql/generated/graphql';
import { StatusField } from './columns/status';
import { DocumentNode } from 'graphql';
import { ActionsField } from './columns/actions';

export const getTableConfig = (
  data: MostRequestHistory[],
  { t }: { t: TFunction },
  refetchQueries: DocumentNode[],
) => [
  {
    name: 'status',
    label: t('common.status.label'),
    options: {
      customBodyRender: (status: MostRequestHistoryStatus) => (
        <StatusField status={status} />
      ),
    },
  },
  {
    name: 'request-type',
    label: t('most.list.history.columns.request-type'),
    options: {
      setCellProps: () => ({ style: { minWidth: '150px' } }),
      customBodyRender: (_: any, column: DataTableMeta) => {
        const record = data[column.rowIndex];

        if (record.queryName) {
          return `${t('most.list.history.columns.request-type-query')}: ${
            record.queryName
          }`;
        }

        return `${t('most.list.history.columns.request-type-task')}: ${
          record.triageName
        }`;
      },
    },
  },
  {
    name: 'store.nationalStoreNumber',
    label: t('most.list.history.columns.store'),
    options: {
      customBodyRender: (storeId: string) => <Chip label={`#${storeId}`} />,
    },
  },
  {
    name: 'device',
    label: t('most.list.history.columns.device'),
  },
  {
    name: 'requestedOn',
    label: t('most.list.history.columns.requested-on'),
    options: {
      isDesktopOnly: true,
      customBodyRender: (value: string) => (
        <DateColumn date={value} withTime={true} />
      ),
    },
  },
  {
    name: 'completedOn',
    label: t('most.list.history.columns.completed-on'),
    options: {
      isDesktopOnly: true,
      customBodyRender: (value: string) => (
        <DateColumn date={value} withTime={true} />
      ),
    },
  },
  {
    name: 'resultDataWithProblems',
    label: t('most.list.history.columns.alerts'),
    options: {
      customBodyRender: (
        resultDataWithProblems: MostRequestHistoryResultDataWithProblem[],
      ) => {
        const problemsCount =
          resultDataWithProblems?.filter((item) => !!item.problem)?.length || 0;
        return problemsCount;
      },
    },
  },
  {
    name: 'actions',
    label: t('common.actions'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const record = data[column.rowIndex];

        return <ActionsField record={record} refetchQueries={refetchQueries} />;
      },
    },
  },
];
